import resources from './resources';

const resourcesWithEmailTemplates = {
  posts: resources.posts,
  companies: resources.companies,
  users: resources.users,
};

export default resourcesWithEmailTemplates;
